const PORTAL_KEY = 'applicant/portal';
const REDIRECT_KEY = 'redirect';
const PREV_AUTHED_IN_KEY = 'applicant_previously_authenticated';

export const getPortal = () => {
    return window.localStorage.getItem(PORTAL_KEY);
};

export const setPortal = contactID => {
    window.localStorage.setItem(PORTAL_KEY, contactID);
};

export const setRedirect = path => {
    window.localStorage.setItem(REDIRECT_KEY, path);
};

export const getRedirect = () => {
    return window.localStorage.getItem(REDIRECT_KEY);
};

export const unsetRedirect = () => {
    window.localStorage.removeItem(REDIRECT_KEY);
};

export const popRedirect = () => {
    const redirect = getRedirect();
    unsetRedirect();

    return redirect;
};

export const getPreviouslyAuthenticated = () => {
    return window.localStorage.getItem(PREV_AUTHED_IN_KEY);
};

export const setPreviouslyAuthenticated = () => {
    return window.localStorage.setItem(PREV_AUTHED_IN_KEY, "1");
};